import { Maybe } from 'app/common/types';

import { get, has } from 'lodash';

const isLikelyToHaveDescendantsPerAction = (action: Maybe<string>) =>
  // Node action (from the prefill)
  action === 'folder' || action === 'directory';

const isLikelyToHaveDescendantsPerData = (data: {}) =>
  // Detect Box folders
  get(data, 'type') === 'folder' ||
  // Detect Dropbox folders
  get(data, 'is_dir') ||
  // Detect Google Drive folders
  get(data, 'mimeType') === 'application/vnd.google-apps.folder' ||
  // Detect OneDrive folders
  has(data, '_path');

// This is a heuristic. Neither a false positive nor a false
// negative should (can) result in errors or break the user experience.
// The goal is to enable a better user experience from our best guess.
const hasPrefillChoiceDescendants = (action: Maybe<string>, data: {}) =>
  isLikelyToHaveDescendantsPerAction(action) ||
  isLikelyToHaveDescendantsPerData(data);

export default hasPrefillChoiceDescendants;
